import Vue from 'vue'
import ActivateVipDialog from './ActivateVipDialog.vue'
import IframeDialog from './IframeDialog.vue'
import UnlockDialog from './UnlockDialog.vue'
import SavePaperDialog from './SavePaperDialog.vue'


export const cache = new Set()

const openDialog = function (component) {
  const div = document.createElement('div')
  const el = document.createElement('div')
  const id = 'dialog-' + Math.random()
  div.appendChild(el)
  document.body.appendChild(div)

  const ComponentConstructor = Vue.extend(component)
  return (propsData = {}) => {
    let instance = new ComponentConstructor({
      propsData
    }).$mount(el)

    const destroyDialog = () => {
      if (cache.has(id)) return
      if (instance && div.parentNode) {
        cache.add(id)
        instance.visible = false
        // 延时是为了在关闭动画执行完毕后卸载组件
        setTimeout(() => {
          cache.delete(id)
          instance.$destroy()
          instance = null
          div.parentNode && div.parentNode.removeChild(div)
        }, 1000)
      }
    }

    if (instance.visible !== undefined) {
      instance.$watch('visible', (val) => {
        !val && destroyDialog()
      })
      Vue.nextTick(() => (instance.visible = true))
    }

    return new Promise((resolve) => {
      instance.$once('done', (data) => {
        destroyDialog()
        resolve(data || true)
      })
      instance.$once('cancel', () => {
        destroyDialog()
        resolve(false)
      })
    })
  }
}

export function OpenActivateVipDialog(propsData) {
  return openDialog(ActivateVipDialog)(propsData)
}

export function OpenIframeDialog(propsData) {
  return openDialog(IframeDialog)(propsData)
}

export function OpenUnlockDialog(propsData) {
  return openDialog(UnlockDialog)(propsData)
}

export function OpenSavePaperDialog(propsData) {
  return openDialog(SavePaperDialog)(propsData)
}